import { safeSentryCaptureException } from '@shared/sentry';

export function startHandlingExceptions(): void {
  self.addEventListener('error', (event: ErrorEvent) => {
    try {
      console.error('Global error caught:', event.message);
      console.error('At:', event.filename + ':' + event.lineno + ':' + event.colno);
      console.error('Error object:', event.error);
      safeSentryCaptureException(
        new Error(
          `Global error caught: ${event.message}, at ${event.filename}:${event.lineno}:${
            event.colno
          }, error object: ${JSON.stringify(event.error)}`
        )
      );
    } catch (e) {
      console.error('Error while capturing error event', e);
    }
  });

  self.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    try {
      console.error('Unhandled promise rejection:', event.reason);
      safeSentryCaptureException(new Error(`Unhandled promise rejection: ${JSON.stringify(event.reason)}`));
    } catch (e) {
      console.error('Error while capturing unhandled promise rejection', e);
    }
  });
}
